import styled from "styled-components";
import { bodyTextRegular, breakpoint, headingText } from "./style";

const FooterElement = styled.footer`
    width: 100%;
    margin: 0px;
    margin-top: 100px;
    padding: 100px;
    border-top: 1px solid #c0c0c0;

    @media ${breakpoint.phone} {
        padding: 40px;
    }
`;

const ContentLine = styled.span`
    display: block;

    ${bodyTextRegular}
    font-size: 14pt;

    &.title {
        ${headingText}
        text-transform: uppercase;
        
    }

`;

const BreakLine = styled.div`
    width: 100%;
    height: 50px;
    content: "";
`;

const Footer = () => {
    return <FooterElement>
        <ContentLine className="title">Deconstructing Proxies</ContentLine>
        <ContentLine>A case study on interactions between dance, technology, and design</ContentLine>
        <BreakLine />
        <ContentLine>Steven Geofrey and Ilya Vidrin,<br />October 2023 - Present (ongoing)</ContentLine>
    </FooterElement>
};

export default Footer;
